const One = () => {
    return (
        <svg
            width="27"
            height="55"
            viewBox="0 0 27 55"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <mask
                id="path-1-outside-1_920_783"
                maskUnits="userSpaceOnUse"
                x="0"
                y="0"
                width="27"
                height="55"
                fill="black"
            >
                <rect fill="white" width="27" height="55" />
                <path d="M16.04 2.6H24.68V53H14.744V13.112L5.24 15.776L2.792 7.28L16.04 2.6Z" />
            </mask>
            <path
                d="M16.04 2.6V0.599997H15.6971L15.3738 0.714205L16.04 2.6ZM24.68 2.6H26.68V0.599997H24.68V2.6ZM24.68 53V55H26.68V53H24.68ZM14.744 53H12.744V55H14.744V53ZM14.744 13.112H16.744V10.4743L14.2042 11.1862L14.744 13.112ZM5.24 15.776L3.31819 16.3297L3.86793 18.2377L5.7798 17.7018L5.24 15.776ZM2.792 7.28L2.12582 5.39421L0.348208 6.02217L0.870186 7.83374L2.792 7.28ZM16.04 4.6H24.68V0.599997H16.04V4.6ZM22.68 2.6V53H26.68V2.6H22.68ZM24.68 51H14.744V55H24.68V51ZM16.744 53V13.112H12.744V53H16.744ZM14.2042 11.1862L4.7002 13.8502L5.7798 17.7018L15.2838 15.0378L14.2042 11.1862ZM7.16181 15.2223L4.71381 6.72625L0.870186 7.83374L3.31819 16.3297L7.16181 15.2223ZM3.45818 9.16579L16.7062 4.48579L15.3738 0.714205L2.12582 5.39421L3.45818 9.16579Z"
                fill="url(#paint0_linear_920_783)"
                mask="url(#path-1-outside-1_920_783)"
            />
            <defs>
                <linearGradient
                    id="paint0_linear_920_783"
                    x1="16"
                    y1="-11"
                    x2="15"
                    y2="55.5"
                    gradientUnits="userSpaceOnUse"
                >
                    <stop stopColor="#1C225A" />
                    <stop offset="1" stopColor="#3B49C0" stopOpacity="0" />
                </linearGradient>
            </defs>
        </svg>
    );
};

export default One;
